"use strict";
/*!
// <copyright file="ColumnGenerator.tsx" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var reactGrid;
    (function (reactGrid) {
        reactGrid.featureName = "CLIReactGridEnableFeature";
        reactGrid.appliedVirtualizedProperty = false;
        function isReactGridUIProps(obj) {
            return obj && obj.Type === "ReactGrid";
        }
        function isIReferenceGroupParent(obj) {
            return obj && obj.Type === "ReferenceGroup";
        }
        var cachedControls = {};
        function registerColumn(controlType, mapperFunc) {
            cachedControls[controlType] = mapperFunc;
        }
        reactGrid.registerColumn = registerColumn;
        var cachedControlProperties = {};
        function registerControlProperty(controlType, propertyName) {
            if (!cachedControlProperties[controlType]) {
                cachedControlProperties[controlType] = {};
            }
            cachedControlProperties[controlType][propertyName] = true;
        }
        reactGrid.registerControlProperty = registerControlProperty;
        function registerControlProperties(controlType, properties) {
            if (!cachedControlProperties[controlType]) {
                cachedControlProperties[controlType] = properties ? properties : {};
            }
            else {
                $dyn.util.objectAssign(cachedControlProperties[controlType], properties);
            }
        }
        reactGrid.registerControlProperties = registerControlProperties;
        function getControlProperties(controlType) {
            return cachedControlProperties[controlType];
        }
        reactGrid.getControlProperties = getControlProperties;
        // TODO: add an interface for columnInfo
        function generateColumn(columnInfo, parentProps) {
            if (cachedControls[columnInfo.TypeName]) {
                return cachedControls[columnInfo.TypeName](columnInfo, parentProps);
            }
            else {
                // Use Input mapperFunc as the default
                return cachedControls.Input(columnInfo, parentProps);
            }
        }
        reactGrid.generateColumn = generateColumn;
        function getId(controlName, root) {
            return root ? controlName + "_" + root.Id : controlName;
        }
        function getVirtualizedFieldName(controlId, propertyName) {
            return "_VIRTUALIZED_" + controlId + "_" + propertyName;
        }
        function getOnEditClick(form) {
            var activeForm = form ? form : $dyn.context($dyn.shell.getActiveForm());
            if (activeForm && $dyn.peek(activeForm.CanSwitchViewMode) && $dyn.peek(activeForm.IsInViewMode)) {
                return function () {
                    activeForm.executeShortcuts(true, "ViewEdit");
                };
            }
            return null;
        }
        function upgradeDiscreteSize(originalSize) {
            if (originalSize === "xsmall" /* xSmall */) {
                return "small" /* Small */;
            }
            else if (originalSize === "small" /* Small */) {
                return "medium" /* Medium */;
            }
            else {
                return originalSize;
            }
        }
        function getSizing(columnInfo, upgradeSize) {
            var controlWidthMode = "Manual" /* Manual */;
            var controlWidth = parseInt($dyn.value(columnInfo.Width), 10);
            if (isNaN(controlWidth)) {
                if ($dyn.layout.sizing.isDiscreteSize($dyn.value(columnInfo.Width))) {
                    controlWidth = upgradeSize ? upgradeDiscreteSize($dyn.value(columnInfo.Width)) : $dyn.value(columnInfo.Width);
                    controlWidthMode = "DiscreteSizing" /* Discrete */;
                }
                else if ($dyn.value(columnInfo.Width) === $dyn.layout.Size.available) {
                    controlWidth = undefined;
                    controlWidthMode = "SizeToAvailable" /* ToAvailable */;
                }
                else {
                    controlWidth = undefined;
                    controlWidthMode = "SizeToContent" /* ToContent */;
                }
            }
            var controlHeightMode = "Manual" /* Manual */;
            var controlHeight = parseInt($dyn.value(columnInfo.Height), 10);
            if (isNaN(controlHeight)) {
                if ($dyn.value(columnInfo.Height) === $dyn.layout.Size.available) {
                    controlHeight = undefined;
                    controlHeightMode = "SizeToAvailable" /* ToAvailable */;
                }
                else {
                    controlHeight = undefined;
                    controlHeightMode = "SizeToContent" /* ToContent */;
                }
            }
            return { height: controlHeight, width: controlWidth, heightMode: controlHeightMode, widthMode: controlWidthMode };
        }
        function getSignDisplay(columnInfo) {
            var columnSignDisplay = $dyn.value(columnInfo.SignDisplay);
            var signDisplay;
            // When Corrections are supported and DisplaceNegative is being used the signs must be allowed, however in this mode
            // they will be strictly controlled by DisplaceNegatve/IsCorrection logic in formatValue, not by the actual value's sign.
            if ($dyn.value(columnInfo.SupportsCorrection) && $dyn.value(columnInfo.DisplaceNegative) !== $dyn.ui.autoValue) {
                columnSignDisplay = $dyn.ui.SignDisplayType.Auto;
            }
            switch (columnSignDisplay) {
                case $dyn.ui.SignDisplayType.None:
                    signDisplay = "n" /* None */;
                    break;
                case $dyn.ui.SignDisplayType.Prefixed:
                    signDisplay = "-n" /* Prefix */;
                    break;
                case $dyn.ui.SignDisplayType.Suffixed:
                    signDisplay = "n-" /* Suffix */;
                    break;
                case $dyn.ui.SignDisplayType.Parentheses:
                    signDisplay = "(n)" /* Parentheses */;
                    break;
                case $dyn.ui.SignDisplayType.Auto:
                default:
                    // Set to undefined to use culture default
                    break;
            }
            return signDisplay;
        }
        function getDateFormat(columnInfo) {
            var dateFormat;
            var columnDateFormat = $dyn.value(columnInfo.DateFormat);
            switch (columnDateFormat) {
                case $dyn.ui.DateFormat.YMD:
                    dateFormat = "y/M/d" /* YMD */;
                    break;
                case $dyn.ui.DateFormat.YDM:
                    dateFormat = "y/d/M" /* YDM */;
                    break;
                case $dyn.ui.DateFormat.MYD:
                    dateFormat = "M/y/d" /* MYD */;
                    break;
                case $dyn.ui.DateFormat.MDY:
                    dateFormat = "M/d/y" /* MDY */;
                    break;
                case $dyn.ui.DateFormat.DYM:
                    dateFormat = "d/y/M" /* DYM */;
                    break;
                case $dyn.ui.DateFormat.DMY:
                    dateFormat = "d/M/y" /* DMY */;
                    break;
                case $dyn.ui.DateFormat.auto:
                default:
                    dateFormat = undefined;
            }
            return dateFormat;
        }
        function setValidity(validityObject, cellProps) {
            var _this = this;
            var validityRowId = this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex);
            var syncManager = this.listControl.syncManager;
            if (validityObject.valid) {
                var newValidity = { userValue: validityObject.userValue };
                var raiseChanges = false;
                if (validityRowId !== $dyn.value(this.listControl.SelectedRowTrackingId)) {
                    // All we have is client side validation when not on the server row
                    newValidity.override = undefined;
                    if (cellProps.Validity && cellProps.Validity.override === false) {
                        raiseChanges = true;
                    }
                }
                syncManager.setValidity(newValidity, validityRowId, this._name, this.DataSourceName);
                if (raiseChanges && $dyn.serverForm) {
                    // need to force a render with a new collection data version
                    $dyn.reactGrid.appliedVirtualizedProperty = false;
                    $dyn.serverForm.UpdateModelManager.raiseChanges();
                }
            }
            else {
                // Failed client-side validation
                syncManager.setValidity({ userValue: validityObject.userValue, override: false, messages: validityObject.messages }, validityRowId, this._name, this.DataSourceName);
                syncManager.changeData(validityRowId, this.Name, function (syncingRowId) {
                    var e_1, _a, e_2, _b;
                    if (_this.messages && $dyn.length(_this.messages) > 0) {
                        try {
                            for (var _c = __values(_this.messages), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var messageId = _d.value;
                                $dyn.messageManager.remove(messageId, _this.Root.Id);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.messages = [];
                    }
                    _this.IsValid(false);
                    if (validityObject.messages) {
                        // clear messages as column.addMessage adds them back
                        syncManager.setValidity({ messages: [] }, syncingRowId, _this._name, _this.DataSourceName);
                        try {
                            for (var _e = __values(validityObject.messages), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var message = _f.value;
                                $dyn.warn({ Message: message }, _this);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                }, function (syncingRowId) {
                    syncManager.setValidity({ override: undefined, messages: [] }, syncingRowId, _this._name, _this.DataSourceName);
                    syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                });
            }
        }
        function clearMessages() {
            var e_3, _a;
            var validityRowId = $dyn.value(this.listControl.InternalSelectedRowTrackingId);
            this.listControl.syncManager.setValidity({ messages: [] }, validityRowId, this._name, this.DataSourceName);
            if (this.messages && $dyn.length(this.messages) > 0) {
                try {
                    for (var _b = __values(this.messages), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var messageId = _c.value;
                        $dyn.messageManager.remove(messageId, this.Root.Id);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                this.messages = [];
            }
        }
        function requestPopupOptions(columnInfo) {
            if (!columnInfo.Popup) {
                columnInfo.highlyResponsivePopups = true;
                columnInfo.pendingPopup = function (pendingPopup) { columnInfo._pendingPopup = pendingPopup; };
                $dyn.ui.popupHost.apply(columnInfo);
                var gridElement_1 = columnInfo.listControl.element;
                var options_1 = {
                    getAnchor: function () {
                        return $(gridElement_1).find(".dyn-activeRowCell [data-dyn-controlname='" + columnInfo._name + "']");
                    },
                    getTarget: function () {
                        return $(gridElement_1).find(".dyn-activeRowCell [data-dyn-controlname='" + columnInfo._name + "'] .dyn-lookup-button");
                    },
                    focusTarget: function () {
                        return $(gridElement_1).find(".dyn-activeRowCell [data-dyn-controlname='" + columnInfo._name + "']");
                    },
                    highlyResponsive: true,
                    positionResize: true,
                    putAnimationOnTarget: true,
                    requestPopup: columnInfo.showPopup,
                    show: columnInfo.ShowFlyout,
                    skipAria: true,
                    takeFocus: false,
                };
                $dyn.util.flyout(options_1, false);
                columnInfo.flyoutOptions = options_1;
            }
        }
        reactGrid.requestPopupOptions = requestPopupOptions;
        function requestPopup(columnInfo) {
            requestPopupOptions(columnInfo);
            $dyn.setValue(columnInfo, "ShowFlyout", true);
        }
        function openLookupOnRef(columnInfo) {
            if (columnInfo.listControl && columnInfo.listControl.ControlLibGridRef) {
                var lookupControlRef = columnInfo.listControl.ControlLibGridRef.getActiveCellRef(columnInfo._name);
                if (lookupControlRef && lookupControlRef.getControlRef) {
                    lookupControlRef = lookupControlRef.getControlRef();
                    if (lookupControlRef && lookupControlRef.openLookup) {
                        lookupControlRef.openLookup();
                    }
                }
            }
        }
        function getLookupProps(columnInfo) {
            var controlOpenLookup = function (lookupProps, closeCallback) {
                var listControl = columnInfo.listControl;
                var serverRowIndex = listControl.getRowIndexFromTrackingId($dyn.value(listControl.SelectedRowTrackingId));
                if (lookupProps && lookupProps.RowIndex !== serverRowIndex) {
                    return;
                }
                if (columnInfo.autoPresentLookupTimer) {
                    columnInfo.autoPresentLookupTimer.cancel();
                    columnInfo.autoPresentLookupTimer = undefined;
                }
                if (!columnInfo.displayedValues) {
                    var currentValidity_1 = listControl.syncManager.getValidity($dyn.value(listControl.SelectedRowTrackingId), columnInfo._name, columnInfo.DataSourceName);
                    if (currentValidity_1 && (currentValidity_1.valid === false || currentValidity_1.override === false)) {
                        columnInfo.displayedValues = function () {
                            var displayedValues = {};
                            displayedValues[columnInfo._name] = currentValidity_1.userValue;
                            return displayedValues;
                        };
                    }
                }
                requestPopup(columnInfo);
                $dyn.observe(columnInfo.ShowFlyout, function (value) {
                    if (!value) {
                        closeCallback && closeCallback();
                        columnInfo.displayedValues = undefined;
                        return false;
                    }
                });
            };
            var controlCloseLookup = function (lookupProps) {
                var serverRowIndex = columnInfo.listControl.getRowIndexFromTrackingId($dyn.value(columnInfo.listControl.SelectedRowTrackingId));
                if (lookupProps && lookupProps.RowIndex !== serverRowIndex) {
                    return;
                }
                if (columnInfo.autoPresentLookupTimer) {
                    columnInfo.autoPresentLookupTimer.cancel();
                    columnInfo.autoPresentLookupTimer = undefined;
                }
                $dyn.setValue(columnInfo, "ShowFlyout", false);
            };
            // Save this off on the columnInfo so it can be called from JSDispatcher
            columnInfo.testOpenLookup = controlOpenLookup;
            var controlOnChange = function (value, inputProps) {
                var serverRowIndex = columnInfo.listControl.getRowIndexFromTrackingId($dyn.value(columnInfo.listControl.SelectedRowTrackingId));
                if (inputProps.RowIndex !== serverRowIndex) {
                    return;
                }
                if (columnInfo.autoPresentLookupTimer) {
                    columnInfo.autoPresentLookupTimer.cancel();
                    columnInfo.autoPresentLookupTimer = undefined;
                }
                var timerLength = $dyn.ui.typeAheadTimer;
                if ($dyn.debug.typeAheadTimer !== undefined) {
                    timerLength = $dyn.debug.typeAheadTimer;
                }
                columnInfo.autoPresentLookupTimer = $dyn.async(function () {
                    columnInfo.autoPresentLookupTimer = undefined;
                    columnInfo.displayedValues = function () {
                        var displayedValues = {};
                        displayedValues[inputProps.Name] = value;
                        return displayedValues;
                    };
                    if ($dyn.value(columnInfo.ShowFlyout)) {
                        if (columnInfo.popupHostElement) {
                            var lookupForm = $dyn.context(columnInfo.popupHostElement);
                            if (lookupForm && $dyn.value(lookupForm.IsFormReady)) {
                                var filterValues = columnInfo.displayedValues(false);
                                filterValues["@activeFilter"] = value;
                                $dyn.callFunction(lookupForm.Filter, lookupForm, [filterValues]);
                            }
                            else {
                                // Flyout isn't ready yet--re-queue.
                                controlOnChange(value, inputProps);
                            }
                        }
                        else {
                            // Flyout isn't ready yet--re-queue.
                            controlOnChange(value, inputProps);
                        }
                    }
                    else {
                        // Flyout needs to be presented.
                        openLookupOnRef(columnInfo);
                    }
                }, timerLength);
            };
            var controlOnBlur = function (event, lookupProps) {
                var relatedTarget;
                var isFlyoutTarget = false;
                if (event && event.relatedTarget) {
                    relatedTarget = event.relatedTarget;
                }
                else if (document.activeElement) {
                    relatedTarget = document.activeElement;
                }
                if (relatedTarget) {
                    isFlyoutTarget = !$dyn.util.flyout.isClosableFocusRegion(relatedTarget);
                    if (isFlyoutTarget) {
                        return false;
                    }
                }
                if (columnInfo.autoPresentLookupTimer && !columnInfo.enterLookupTimer) {
                    columnInfo.autoPresentLookupTimer.cancel();
                    columnInfo.autoPresentLookupTimer = undefined;
                }
                if (columnInfo.IsFocused) {
                    var focusedElement = event.relatedTarget || document.activeElement;
                    var focusedInsidePopup = (columnInfo.Popup && columnInfo.Popup() && focusedElement && $.contains(columnInfo.Popup()[0], focusedElement));
                    // Closing the lookup is a blocking command and thus focus goes to the blocking div and back
                    var focusedBlockingDiv = (focusedElement && focusedElement.id === "ShellBlockingDiv");
                    if (!focusedInsidePopup && !focusedBlockingDiv) {
                        columnInfo.IsFocused = false;
                        if (columnInfo._pendingPopup) {
                            columnInfo._pendingPopup.cancel();
                        }
                        else if ($dyn.value(columnInfo.ShowFlyout)) {
                            $dyn.setValue(columnInfo, "ShowFlyout", false);
                        }
                    }
                    else {
                        // focus is inside ax popup or on blocking div, do not want to blur the control
                        return false;
                    }
                }
            };
            var controlOnFocus = function (event, lookupProps) {
                if (!columnInfo.IsFocused) {
                    columnInfo.IsFocused = true;
                }
            };
            var controlOnKeyDown = function (event, controlProps) {
                if ($dyn.value(columnInfo.ShowFlyout)) {
                    if (columnInfo.popupHostElement) {
                        var lookupForm_1 = $dyn.context(columnInfo.popupHostElement);
                        if (lookupForm_1) {
                            if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: $dyn.util.Lookup.KeysToSendToLookup })) {
                                var sendKeyToGrid = function () {
                                    if (columnInfo.enterLookupTimer) {
                                        columnInfo.enterLookupTimer = undefined;
                                    }
                                    var gridSelector = $dyn.value(lookupForm_1.UseReactGrid) ? "[data-dyn-role='ReactList']" : "[data-dyn-role='List']";
                                    var grid = $dyn.context($(columnInfo.popupHostElement).find(gridSelector)[0]);
                                    if (grid) {
                                        if ($dyn.value(lookupForm_1.UseReactGrid)) {
                                            if (grid.ControlLibGridRef) {
                                                // TODO handleKeyDown is protected and can't be directly called
                                                // tslint:disable-next-line:no-string-literal
                                                grid.ControlLibGridRef["handleKeyDown"](event);
                                            }
                                        }
                                        else if (grid.RowKeyDown) {
                                            grid.RowKeyDown(event.nativeEvent);
                                        }
                                    }
                                };
                                // If the timeout to filter the flyout has started, make sure to send the enter after we send the filter
                                if (columnInfo.autoPresentLookupTimer && $dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: $dyn.ui.KeyCodes.enter })) {
                                    event.persist && event.persist();
                                    var timerLength = $dyn.ui.typeAheadTimer;
                                    if ($dyn.debug.typeAheadTimer !== undefined) {
                                        timerLength = $dyn.debug.typeAheadTimer;
                                    }
                                    columnInfo.enterLookupTimer = $dyn.async(sendKeyToGrid, timerLength, "Sending enter to lookup grid", columnInfo);
                                }
                                else {
                                    sendKeyToGrid();
                                }
                                event.stopPropagation && event.stopPropagation();
                            }
                            else if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: $dyn.ui.KeyCodes.downArrow, alt: true })) {
                                if ($dyn.value(lookupForm_1.IsFormReady)) {
                                    lookupForm_1.TakeFocus = true;
                                    lookupForm_1.takeFocusToggled = true;
                                    lookupForm_1.takeNavigationFocus();
                                    event.stopPropagation && event.stopPropagation();
                                }
                            }
                        }
                    }
                    else if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true })) {
                        $dyn.setValue(columnInfo, "ShowFlyout", false);
                    }
                }
            };
            var controlOnKeyUp = function (event, controlProps) {
                if ($dyn.value(columnInfo.ShowFlyout) && columnInfo.popupHostElement) {
                    var lookupForm = $dyn.context(columnInfo.popupHostElement);
                    if (lookupForm &&
                        $dyn.value(lookupForm.UseReactGrid) &&
                        $dyn.util.isShortcutKeyPressed(event.nativeEvent, {
                            keyCode: [$dyn.ui.KeyCodes.upArrow, $dyn.ui.KeyCodes.downArrow, $dyn.ui.KeyCodes.pageUp, $dyn.ui.KeyCodes.pageDown]
                        })) {
                        var grid = $dyn.context($(columnInfo.popupHostElement).find("[data-dyn-role='ReactList']")[0]);
                        if (grid) {
                            // react grid has optimization to not call row change until key up
                            grid.keyUp(event.nativeEvent);
                        }
                    }
                }
            };
            return {
                AllowTyping: !$dyn.value(columnInfo.LookupOnly),
                CloseLookup: controlCloseLookup,
                OnBlur: controlOnBlur,
                OnChange: controlOnChange,
                OnFocus: controlOnFocus,
                OnKeyDown: controlOnKeyDown,
                OnKeyUp: controlOnKeyUp,
                OpenLookup: controlOpenLookup,
            };
        }
        // Takes a string in the format "r g b" and returns it in the format "rgb(r,g,b)"
        function getColor(color) {
            if (!color) {
                return;
            }
            var splitValues = color.split(" ", 3);
            if (splitValues.length !== 3) { // colors must be in the format "r g b"
                return;
            }
            return "rgb(" + splitValues.join(",") + ")";
        }
        var integerControls = function (columnInfo, parentProps) {
            var integerControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, $dyn.value(columnInfo.LookupButton));
                var displaceNegative = 0;
                if ($dyn.value(columnInfo.DisplaceNegative) !== "Auto") {
                    displaceNegative = parseInt($dyn.value(columnInfo.DisplaceNegative), 10);
                }
                var controlSetValue = function (newValue, cellProps) {
                    var _this = this;
                    // Let sync manager handle set value
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValue], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue;
                var controlSetValidity = setValidity.bind(columnInfo);
                var maxValue = (columnInfo.TypeName === "Integer") ? "2147483647" : "9223372036854775807";
                var minValue = (columnInfo.TypeName === "Integer") ? "-2147483648" : "-9223372036854775808";
                var showZeroText = $dyn.value(columnInfo.ShowZero);
                var showZeroBool = (showZeroText === "Auto");
                if (!showZeroBool) {
                    showZeroBool = $dyn.util.stringToBoolean(showZeroText);
                }
                var controlIsDefault = ((isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl)) ||
                    (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl));
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = (controlIsDefault || controlIsHyperlink) ? function (columnProps) {
                    if (isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && columnProps.IsDefaultControl) {
                        parentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else if (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl && parentProps.ParentProps.NavigationEnabled) {
                        parentProps.ParentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else {
                        if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                            (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                            // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                            return;
                        }
                        $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                    }
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink || controlIsDefault) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var integerControlProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    AllowTotal: $dyn.value(columnInfo.AllowTotal),
                    BackgroundColor: getColor($dyn.value(columnInfo.BackgroundColor)),
                    DisplaceNegative: displaceNegative,
                    Enabled: $dyn.value(columnInfo.Enabled),
                    ForegroundColor: getColor($dyn.value(columnInfo.ForegroundColor)),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsDefaultControl: controlIsDefault,
                    IsHyperlink: controlIsHyperlink,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    MaxValue: maxValue,
                    MinValue: minValue,
                    Name: columnInfo._name,
                    OnEditClick: getOnEditClick(columnInfo.Root),
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    Required: $dyn.value(columnInfo.Required),
                    RotateSign: $dyn.util.stringToBoolean($dyn.value(columnInfo.RotateSign)),
                    SetValidity: controlSetValidity,
                    SetValue: controlSetValue,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    ShowLookupButton: $dyn.value(columnInfo.LookupButton),
                    ShowZero: showZeroBool,
                    SignDisplay: getSignDisplay(columnInfo),
                    Skip: $dyn.value(columnInfo.Skip),
                    ThousandSeparator: "" /* None */,
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var alignment = $dyn.value(columnInfo.Alignment);
                if (alignment && alignment !== "Auto") {
                    conditionalProps.Alignment = alignment.toLowerCase();
                }
                if ($dyn.value(columnInfo.LookupButton)) {
                    $dyn.util.objectAssign(integerControlProps, getLookupProps(columnInfo));
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                columnInfo.pasteFromExcel = controlSetValue;
                if (columnInfo.FieldName) {
                    boundProperties.push("Value", "Validity", "DataVersion");
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                conditionalProps.BoundProperties = boundProperties;
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(integerControlProps, conditionalProps);
                    integerControl = React.createElement(ControlLibrary.IntEdit, integerControlProps);
                }
                else {
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(integerControlProps, conditionalProps, cellProps);
                    integerControl = React.createElement(ControlLibrary.IntEditCell, integerControlProps);
                }
            }
            return integerControl;
        };
        $dyn.reactGrid.registerColumn("Integer", integerControls);
        $dyn.reactGrid.registerColumn("Int64", integerControls);
        var integerPropertiesToObserve = {
            Alignment: true,
            AllowTotal: true,
            DisplaceNegative: true,
            RotateSign: true,
            ShowZero: true,
            SignDisplay: true,
            TotalShown: true,
        };
        $dyn.reactGrid.registerControlProperties("Integer", integerPropertiesToObserve);
        $dyn.reactGrid.registerControlProperties("Int64", integerPropertiesToObserve);
        $dyn.reactGrid.registerColumn("Real", function (columnInfo, parentProps) {
            var realControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, $dyn.value(columnInfo.LookupButton));
                var displaceNegative = 0;
                if ($dyn.value(columnInfo.DisplaceNegative) !== "Auto") {
                    displaceNegative = parseInt($dyn.value(columnInfo.DisplaceNegative), 10);
                }
                var controlSetValue = function (newValue, cellProps) {
                    var _this = this;
                    // Let sync manager handle set value
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValue], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue;
                var controlSetValidity = setValidity.bind(columnInfo);
                var showZeroText = $dyn.value(columnInfo.ShowZero);
                var showZeroBool = (showZeroText === "Auto");
                if (!showZeroBool) {
                    showZeroBool = $dyn.util.stringToBoolean(showZeroText);
                }
                var controlIsDefault = ((isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl)) ||
                    (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl));
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = (controlIsDefault || controlIsHyperlink) ? function (columnProps) {
                    if (isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && columnProps.IsDefaultControl) {
                        parentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else if (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl && parentProps.ParentProps.NavigationEnabled) {
                        parentProps.ParentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else {
                        if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                            (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                            // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                            return;
                        }
                        $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                    }
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink || controlIsDefault) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var realControlProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    AllowTotal: $dyn.value(columnInfo.AllowTotal),
                    BackgroundColor: getColor($dyn.value(columnInfo.BackgroundColor)),
                    DisplaceNegative: displaceNegative,
                    Enabled: $dyn.value(columnInfo.Enabled),
                    ForegroundColor: getColor($dyn.value(columnInfo.ForegroundColor)),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsDefaultControl: controlIsDefault,
                    IsHyperlink: controlIsHyperlink,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    Name: columnInfo._name,
                    OnEditClick: getOnEditClick(columnInfo.Root),
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    Required: $dyn.value(columnInfo.Required),
                    RotateSign: $dyn.util.stringToBoolean($dyn.value(columnInfo.RotateSign)),
                    SetValidity: controlSetValidity,
                    SetValue: controlSetValue,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    ShowLookupButton: $dyn.value(columnInfo.LookupButton),
                    ShowZero: showZeroBool,
                    SignDisplay: getSignDisplay(columnInfo),
                    Skip: $dyn.value(columnInfo.Skip),
                    SupportsCorrection: $dyn.value(columnInfo.SupportsCorrection),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if ($dyn.value(columnInfo.NoOfDecimals) !== undefined && $dyn.value(columnInfo.NoOfDecimals) !== "Auto") {
                    conditionalProps.NumberOfDecimals = $dyn.value(columnInfo.NoOfDecimals);
                }
                if ($dyn.value(columnInfo.MinNoOfDecimals) !== undefined && $dyn.value(columnInfo.MinNoOfDecimals) !== "Auto") {
                    conditionalProps.MinNumberOfDecimals = $dyn.value(columnInfo.MinNoOfDecimals);
                }
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var alignment = $dyn.value(columnInfo.Alignment);
                if (alignment && alignment !== "Auto") {
                    conditionalProps.Alignment = alignment.toLowerCase();
                }
                if ($dyn.value(columnInfo.LookupButton)) {
                    $dyn.util.objectAssign(realControlProps, getLookupProps(columnInfo));
                }
                var thousandSep = $dyn.value(columnInfo.ThousandSeparator);
                if (thousandSep !== undefined && thousandSep !== $dyn.ui.ThousandSeparator.auto) {
                    switch (thousandSep) {
                        case $dyn.ui.ThousandSeparator.none:
                            conditionalProps.ThousandSeparator = "" /* None */;
                            break;
                        case $dyn.ui.ThousandSeparator.comma:
                            conditionalProps.ThousandSeparator = "," /* Comma */;
                            break;
                        case $dyn.ui.ThousandSeparator.space:
                            conditionalProps.ThousandSeparator = " " /* Space */;
                            break;
                        case $dyn.ui.ThousandSeparator.apostrophe:
                            conditionalProps.ThousandSeparator = "'" /* Apostrophe */;
                            break;
                        case $dyn.ui.ThousandSeparator.dot:
                            conditionalProps.ThousandSeparator = "." /* Dot */;
                            break;
                    }
                }
                var decimalSep = $dyn.value(columnInfo.DecimalSeparator);
                if (decimalSep !== undefined && decimalSep !== $dyn.ui.DecimalSeparator.auto) {
                    switch (decimalSep) {
                        case $dyn.ui.DecimalSeparator.comma:
                            conditionalProps.DecimalSeparator = "," /* Comma */;
                            break;
                        case $dyn.ui.DecimalSeparator.dot:
                            conditionalProps.DecimalSeparator = "." /* Dot */;
                            break;
                    }
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                if ($dyn.value(columnInfo.SupportsCorrection)) {
                    boundProperties.push("IsCorrection");
                    conditionalProps.IsCorrection = { FieldName: getVirtualizedFieldName(columnInfo._name, "IsCorrection"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.IsCorrection = false;
                }
                if (columnInfo.FieldName) {
                    boundProperties.push("Value", "Validity", "DataVersion");
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                columnInfo.pasteFromExcel = controlSetValue;
                conditionalProps.BoundProperties = boundProperties;
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(realControlProps, conditionalProps);
                    realControl = React.createElement(ControlLibrary.RealEdit, realControlProps);
                }
                else {
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(realControlProps, conditionalProps, cellProps);
                    realControl = React.createElement(ControlLibrary.RealEditCell, realControlProps);
                }
            }
            return realControl;
        });
        $dyn.reactGrid.registerControlProperties("Real", {
            Alignment: true,
            AllowTotal: true,
            DecimalSeparator: true,
            DisplaceNegative: true,
            MinNoOfDecimals: true,
            NoOfDecimals: true,
            RotateSign: true,
            ShowZero: true,
            SignDisplay: true,
            SupportsCorrection: true,
            ThousandSeparator: true,
            TotalShown: true,
        });
        $dyn.reactGrid.registerColumn("Time", function (columnInfo, parentProps) {
            var timeControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, true);
                // 24 hour time
                var is24HourTime = $dyn.value(columnInfo.TimeFormat).toLowerCase() === "auto" ? undefined : $dyn.value(columnInfo.TimeFormat).toLowerCase() === "hour24";
                // Separator
                var separatorName = $dyn.value(columnInfo.TimeSeparator).toLocaleLowerCase();
                var separator = void 0;
                // TODO: use enum instead of string constants
                switch (separatorName) {
                    case "colon":
                        separator = ":" /* Colon */;
                        break;
                    case "comma":
                        separator = "," /* Comma */;
                        break;
                    case "dot":
                        separator = "." /* Dot */;
                        break;
                    case "space":
                        separator = " " /* Space */;
                        break;
                    case "slash":
                        separator = "/" /* Slash */;
                        break;
                    case "none":
                        separator = "" /* None */;
                        break;
                    default:
                        separator = undefined;
                }
                var controlSetValue_1 = function (newValue, cellProps) {
                    var _this = this;
                    // Let sync manager handle set value
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValue], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue_1;
                var controlOnEditClick = getOnEditClick(columnInfo.Root);
                var controlSetValidity = setValidity.bind(columnInfo);
                var controlIsDefault = ((isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl)) ||
                    (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl));
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = (controlIsDefault || controlIsHyperlink) ? function (columnProps) {
                    if (isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && columnProps.IsDefaultControl) {
                        parentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else if (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl && parentProps.ParentProps.NavigationEnabled) {
                        parentProps.ParentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else {
                        if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                            (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                            // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                            return;
                        }
                        $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                    }
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink || controlIsDefault) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var timeControlProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    BackgroundColor: getColor($dyn.value(columnInfo.BackgroundColor)),
                    Enabled: $dyn.value(columnInfo.Enabled),
                    ForegroundColor: getColor($dyn.value(columnInfo.ForegroundColor)),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    Is24Hour: is24HourTime,
                    IsDefaultControl: controlIsDefault,
                    IsHyperlink: controlIsHyperlink,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    Name: columnInfo._name,
                    OnEditClick: controlOnEditClick,
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    Required: $dyn.value(columnInfo.Required),
                    Separator: separator,
                    SetValidity: controlSetValidity,
                    SetValue: controlSetValue_1,
                    ShowHours: $dyn.value(columnInfo.TimeHours),
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    ShowLookupButton: $dyn.value(columnInfo.LookupButton),
                    ShowMinutes: $dyn.value(columnInfo.TimeMinutes),
                    ShowSeconds: $dyn.value(columnInfo.TimeSeconds),
                    Skip: $dyn.value(columnInfo.Skip),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var alignment = $dyn.value(columnInfo.Alignment);
                if (alignment && alignment !== "Auto") {
                    conditionalProps.Alignment = alignment.toLowerCase();
                }
                if ($dyn.value(columnInfo.LookupButton)) {
                    $dyn.util.objectAssign(timeControlProps, getLookupProps(columnInfo));
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                columnInfo.pasteFromExcel = function (value, cellProps) {
                    // Need to figure out what format excel will be in
                    var dateTime = moment.utc(value, "hh:mm:ss A");
                    var timeAsSeconds = 0;
                    if (dateTime && dateTime.isValid()) {
                        timeAsSeconds = 3600 * dateTime.hour() + 60 * dateTime.minute() + dateTime.second();
                    }
                    controlSetValue_1(timeAsSeconds, cellProps);
                };
                if (columnInfo.FieldName) {
                    boundProperties.push("Value", "Validity", "DataVersion");
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                conditionalProps.BoundProperties = boundProperties;
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(timeControlProps, conditionalProps);
                    timeControl = React.createElement(ControlLibrary.TimeEdit, timeControlProps);
                }
                else {
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(timeControlProps, conditionalProps, cellProps);
                    timeControl = React.createElement(ControlLibrary.TimeEditCell, timeControlProps);
                }
            }
            return timeControl;
        });
        $dyn.reactGrid.registerControlProperties("Time", {
            Alignment: true,
            TimeFormat: true,
            TimeHours: true,
            TimeMinutes: true,
            TimeSeconds: true,
            TimeSeparator: true,
        });
        var dateControls = function (columnInfo, parentProps) {
            var dateControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, true);
                var isDateTime_1 = (columnInfo.TypeName === "DateTime");
                var controlSetValue = function (newValue, cellProps) {
                    var _this = this;
                    if (newValue !== "") {
                        var valueFormat = isDateTime_1 ? "YYYY-MM-DDTHH:mm:ss" : "YYYY-MM-DD";
                        newValue = moment.utc(newValue).format(valueFormat);
                    }
                    // Let sync manager handle set value
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValue], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue;
                var controlSetValidity = setValidity.bind(columnInfo);
                var controlOnEditClick = getOnEditClick(columnInfo.Root);
                var dateFormat = getDateFormat(columnInfo);
                var dateDay = void 0;
                if ($dyn.value(columnInfo.DateDay)) {
                    // TODO: use enum instead of string constants
                    switch ($dyn.value(columnInfo.DateDay).toLowerCase()) {
                        case "none":
                            dateDay = "" /* None */;
                            break;
                        case "digits1or2":
                            dateDay = "D" /* D */;
                            break;
                        case "digits2":
                            dateDay = "DD" /* DD */;
                            break;
                    }
                }
                var dateMonth = void 0;
                if ($dyn.value(columnInfo.DateMonth)) {
                    // TODO: use enum instead of string constants
                    switch ($dyn.value(columnInfo.DateMonth).toLowerCase()) {
                        case "none":
                            dateMonth = "" /* None */;
                            break;
                        case "digits1or2":
                            dateMonth = "M" /* M */;
                            break;
                        case "digits2":
                            dateMonth = "MM" /* MM */;
                            break;
                        case "short":
                            dateMonth = "MMM" /* Short */;
                            break;
                        case "long":
                            dateMonth = "MMMM" /* Long */;
                            break;
                    }
                }
                var dateYear = void 0;
                if ($dyn.value(columnInfo.DateYear)) {
                    // TODO: use enum instead of string constants
                    switch ($dyn.value(columnInfo.DateYear).toLowerCase()) {
                        case "none":
                            dateYear = "" /* None */;
                            break;
                        case "digits2":
                            dateYear = "YY" /* YY */;
                            break;
                        case "digits4":
                            dateYear = "YYYY" /* YYYY */;
                            break;
                    }
                }
                var separatorOne = void 0;
                var separatorTwo = void 0;
                if ($dyn.value(columnInfo.DateSeparator) !== "Auto") {
                    var controlDateSeparatorValue = void 0;
                    // If any of the separators are a space, that is communicated from the server as "(space)".  Replace that with a space character.
                    // If any of the separators are null, that is communicated from the server as "(none)".  Replace that with a none character 'n' which later replaces with empty char.
                    var noneChar = "n";
                    if ($dyn.value(columnInfo.DateSeparator)) {
                        controlDateSeparatorValue = $dyn.value(columnInfo.DateSeparator).replace(/\(space\)/gi, " ").replace(/\(none\)/gi, noneChar);
                        separatorOne = controlDateSeparatorValue.substr(0, 1);
                        separatorTwo = controlDateSeparatorValue.substr(1, 1);
                        if (separatorOne === noneChar) {
                            separatorOne = "";
                        }
                        if (separatorTwo === noneChar) {
                            separatorTwo = "";
                        }
                    }
                }
                var controlIsDefault = ((isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl)) ||
                    (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl));
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = (controlIsDefault || controlIsHyperlink) ? function (columnProps) {
                    if (isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && columnProps.IsDefaultControl) {
                        parentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else if (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl && parentProps.ParentProps.NavigationEnabled) {
                        parentProps.ParentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else {
                        if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                            (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                            // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                            return;
                        }
                        $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                    }
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink || controlIsDefault) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var altToday = $dyn.user() ? $dyn.user().UserSessionDate() : undefined;
                var dateControlProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    AlternateToday: altToday,
                    BackgroundColor: getColor($dyn.value(columnInfo.BackgroundColor)),
                    ComboboxTypeAhead: $dyn.util.isFlightEnabled($dyn.controls.comboboxTypeAheadFeature),
                    DateDay: dateDay,
                    DateFormat: dateFormat,
                    DateMonth: dateMonth,
                    DateSeparator1: separatorOne,
                    DateSeparator2: separatorTwo,
                    DateYear: dateYear,
                    Enabled: $dyn.value(columnInfo.Enabled),
                    ForegroundColor: getColor($dyn.value(columnInfo.ForegroundColor)),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsDefaultControl: controlIsDefault,
                    IsHyperlink: controlIsHyperlink,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    MaxDateLabel: $dyn.value(columnInfo.MaxDateLabel),
                    Name: columnInfo._name,
                    OnEditClick: controlOnEditClick,
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    Required: $dyn.value(columnInfo.Required),
                    SetValidity: controlSetValidity,
                    SetValue: controlSetValue,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    ShowLookupButton: $dyn.value(columnInfo.LookupButton) && $dyn.value(columnInfo.CanOpenLookupForm),
                    ValueInUtc: true,
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                if (isDateTime_1) {
                    var is24Hour = $dyn.value(columnInfo.TimeFormat) === "Auto" ? undefined : $dyn.value(columnInfo.TimeFormat).toLowerCase() === "hour24";
                    var timeSeparator = $dyn.value(columnInfo.TimeSeparator) === "Auto" ? undefined : $dyn.value(columnInfo.TimeSeparator);
                    var applyTimeZonePreference = $dyn.value(columnInfo.TimeZonePreference) === $dyn.util.TimeZonePreference.none ? false : true;
                    $dyn.util.objectAssign(dateControlProps, {
                        IgnoreTime: false,
                        Is24Hour: is24Hour,
                        ShowHours: $dyn.value(columnInfo.TimeHours),
                        ShowLabel: $dyn.value(columnInfo.ShowLabel),
                        ShowMinutes: $dyn.value(columnInfo.TimeMinute),
                        ShowSeconds: $dyn.value(columnInfo.TimeSeconds),
                        Skip: $dyn.value(columnInfo.Skip),
                        TimeSeparator: timeSeparator,
                        TimeZoneName: $dyn.value(columnInfo.TimeZoneName),
                        UseUserTimeZone: applyTimeZonePreference,
                    });
                }
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var alignment = $dyn.value(columnInfo.Alignment);
                if (alignment && alignment !== "Auto") {
                    conditionalProps.Alignment = alignment.toLowerCase();
                }
                if ($dyn.value(columnInfo.LookupButton) && $dyn.value(columnInfo.CanOpenLookupForm)) {
                    $dyn.util.objectAssign(dateControlProps, getLookupProps(columnInfo));
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                // May need logic here to parse date from excel and format into wire format
                columnInfo.pasteFromExcel = controlSetValue;
                conditionalProps.BoundProperties = boundProperties;
                if (columnInfo.FieldName) {
                    boundProperties.push("Value", "Validity", "DataVersion");
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(dateControlProps, conditionalProps);
                    dateControl = React.createElement(ControlLibrary.DateEdit, dateControlProps);
                }
                else {
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(dateControlProps, conditionalProps, cellProps);
                    dateControl = React.createElement(ControlLibrary.DateEditCell, dateControlProps);
                }
            }
            return dateControl;
        };
        $dyn.reactGrid.registerColumn("Date", dateControls);
        $dyn.reactGrid.registerColumn("DateTime", dateControls);
        var datePropertiesToObserve = {
            Alignment: true,
            CanOpenLookupForm: true,
            DateDay: true,
            DateFormat: true,
            DateMonth: true,
            DateSeparator: true,
            DateYear: true,
            TimeFormat: true,
            TimeHours: true,
            TimeMinute: true,
            TimeSeconds: true,
            TimeSeparator: true,
            TimeZoneName: true,
            TimeZonePreference: true,
        };
        $dyn.reactGrid.registerControlProperties("Date", datePropertiesToObserve);
        $dyn.reactGrid.registerControlProperties("DateTime", datePropertiesToObserve);
        $dyn.reactGrid.registerColumn("ComboBox", function (columnInfo, parentProps) {
            var comboBoxControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, true);
                var items = $dyn.value(columnInfo.Items);
                var controlItems_1 = $dyn.util.convertItems(items);
                // save off for testing purposes
                columnInfo.ComboBoxItems = controlItems_1;
                var controlSetSelectedItem_1 = function (newValue, cellProps) {
                    var _this = this;
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                _this.listControl.syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetSelectedItem, _this, [newValue], callback, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetSelectedItem = controlSetSelectedItem_1;
                var controlSetValidity = setValidity.bind(columnInfo);
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = controlIsHyperlink ? function (columnProps) {
                    if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                        (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                        // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                        return;
                    }
                    $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var comboBoxProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    ComboboxTypeAhead: $dyn.util.isFlightEnabled($dyn.controls.comboboxTypeAheadFeature),
                    Enabled: $dyn.value(columnInfo.Enabled),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsHyperlink: controlIsHyperlink,
                    Items: controlItems_1,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    Name: columnInfo._name,
                    OnEditClick: getOnEditClick(columnInfo.Root),
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    OnSelectedItem: controlSetSelectedItem_1,
                    Required: $dyn.value(columnInfo.Required),
                    SetValidity: controlSetValidity,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    Skip: $dyn.value(columnInfo.Skip),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                columnInfo.pasteFromExcel = function (newValue, cellProps) {
                    var selectedItem = ControlLibrary.getSelectedItemByText(newValue, controlItems_1);
                    controlSetSelectedItem_1(selectedItem.value, cellProps);
                };
                if (columnInfo.FieldName) {
                    boundProperties.push("SelectedItem", "Validity", "DataVersion");
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.SelectedItem = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else {
                    conditionalProps.SelectedItem = $dyn.value(columnInfo.SelectedItem);
                }
                conditionalProps.BoundProperties = boundProperties;
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(comboBoxProps, conditionalProps);
                    comboBoxControl = React.createElement(ControlLibrary.ComboBox, comboBoxProps);
                }
                else {
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(comboBoxProps, conditionalProps, cellProps);
                    comboBoxControl = React.createElement(ControlLibrary.ComboBoxCell, comboBoxProps);
                }
            }
            return comboBoxControl;
        });
        $dyn.reactGrid.registerControlProperty("ComboBox", "Items");
        $dyn.reactGrid.registerColumn("CheckBox", function (columnInfo, parentProps) {
            var checkBoxControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo);
                var controlSetValue = function (newValue, cellProps) {
                    var _this = this;
                    var syncManager = this.listControl.syncManager;
                    // Server sends down value as "1" or "0"
                    var newValueAsBoolean = $dyn.util.stringToBoolean(newValue);
                    syncManager.setInternalValue(newValueAsBoolean ? "1" : "0", this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        var callback = function () {
                            var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            if (setDataVersion) {
                                syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValueAsBoolean], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue;
                var checkBoxProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    Enabled: $dyn.value(columnInfo.Enabled),
                    FalseText: $dyn.label("CheckBox_ToggleFalseText"),
                    HelpText: $dyn.value(columnInfo.HelpText),
                    Id: getId(columnInfo._name, columnInfo.Root),
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    Name: columnInfo._name,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    SetValue: controlSetValue,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    Skip: $dyn.value(columnInfo.Skip),
                    TrueText: $dyn.label("CheckBox_ToggleTrueText"),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                columnInfo.pasteFromExcel = controlSetValue;
                if (columnInfo.FieldName) {
                    conditionalProps.BoundProperties = ["Value", "DataVersion"];
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else if ($dyn.value(columnInfo.Value)) {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                if (isIReferenceGroupParent(parentProps)) {
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(checkBoxProps, conditionalProps);
                    checkBoxControl = React.createElement(ControlLibrary.CheckBox, checkBoxProps);
                }
                else {
                    if (parentProps.Mode === "List") {
                        conditionalProps.BoxType = "TextOnly" /* TextOnly */;
                    }
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(checkBoxProps, conditionalProps, cellProps);
                    checkBoxControl = React.createElement(ControlLibrary.CheckBoxCell, checkBoxProps);
                }
            }
            return checkBoxControl;
        });
        $dyn.reactGrid.registerColumn("Image", function (columnInfo, parentProps) {
            var imageControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo);
                var boundProperties = ["EncodedData"];
                var fieldName = getVirtualizedFieldName(columnInfo._name, "Value");
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var imageProps = {
                    BoundProperties: boundProperties,
                    EncodedData: { FieldName: fieldName, DataSourceName: columnInfo.DataSourceName },
                    FitMode: "fit" /* Fit */,
                    Height: sizing.height,
                    HeightMode: sizing.heightMode,
                    HelpText: $dyn.value(columnInfo.HelpText),
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    Name: columnInfo._name,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    Skip: $dyn.value(columnInfo.Skip),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                if (columnInfo.Click) {
                    var handleClick = function () {
                        if ($dyn.value(columnInfo.Enabled)) {
                            $dyn.callFunction(columnInfo.Click, columnInfo);
                        }
                    };
                    conditionalProps.OnClick = handleClick;
                }
                if (parentProps.Name === "AppListGrid" && columnInfo._name === "AppIconAndColor") {
                    conditionalProps.ContainerStyle = {
                        borderRadius: "50%",
                    };
                    imageProps.BoundProperties.push("BackgroundColor");
                    conditionalProps.BackgroundColor = { FieldName: getVirtualizedFieldName("AppIconAndColor", "BackgroundColor"), DataSourceName: columnInfo.DataSourceName };
                }
                $dyn.util.objectAssign(imageProps, conditionalProps);
                imageControl = React.createElement(ControlLibrary.ImageEditCell, imageProps);
            }
            return imageControl;
        });
        $dyn.reactGrid.registerColumn("ReferenceGroup", function (columnInfo, parentProps) {
            var e_4, _a;
            var refGroupControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, true);
                var refGroupChildren = [];
                var refGroupChildCols = [];
                var refGroupElement = columnInfo._element || columnInfo.element; // Depending on if serverform bound the control
                if (refGroupElement) {
                    var childValues = {
                        DataSourceName: [],
                        FieldName: [],
                    };
                    var lookupProps = getLookupProps(columnInfo);
                    var controlIsDefault = parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl);
                    var refDynChildren = $dyn.value(refGroupElement.dynChildren);
                    if (refDynChildren) {
                        try {
                            for (var refDynChildren_1 = __values(refDynChildren), refDynChildren_1_1 = refDynChildren_1.next(); !refDynChildren_1_1.done; refDynChildren_1_1 = refDynChildren_1.next()) {
                                var refDynChild = refDynChildren_1_1.value;
                                var childControl = $dyn.controlOptions(refDynChild);
                                childControl.listControl = columnInfo.listControl;
                                childControl.Name = childControl._name;
                                childValues.FieldName.push(childControl.FieldName);
                                childValues.DataSourceName.push(childControl.DataSourceName);
                                var refGroupParentProps = {
                                    IsDefaultControl: controlIsDefault,
                                    OnChange: lookupProps.OnChange,
                                    OnMouseEnter: parentProps.OnMouseEnter,
                                    OnMouseLeave: parentProps.OnMouseLeave,
                                    ParentProps: parentProps,
                                    Type: "ReferenceGroup",
                                };
                                var refGroupChild = $dyn.reactGrid.generateColumn(childControl, refGroupParentProps);
                                if (refGroupChild) { // can be null if not Visible
                                    refGroupChildren.push(refGroupChild);
                                }
                                refGroupChildCols.push(childControl);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (refDynChildren_1_1 && !refDynChildren_1_1.done && (_a = refDynChildren_1.return)) _a.call(refDynChildren_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                    columnInfo.ChildCols = refGroupChildCols;
                    var boundProperties = ["ChildValues", "Validity", "DataVersion"];
                    var controlSetValidity = setValidity.bind(columnInfo);
                    var controlResolveChanges = function (cellProps) {
                        var _this = this;
                        var syncManager = this.listControl.syncManager;
                        syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingId) {
                            clearMessages.apply(_this);
                            $dyn.callFunction(_this.ResolveChanges, _this, undefined, null /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, null /*failureCallback*/);
                        });
                    }.bind(columnInfo);
                    columnInfo.pasteFromExcel = controlResolveChanges;
                    var refGroupProps = {
                        AllowEdit: $dyn.value(columnInfo.AllowEdit),
                        BoundProperties: boundProperties,
                        ChildValues: childValues,
                        CloseLookup: lookupProps.CloseLookup,
                        DataVersion: { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName },
                        Enabled: $dyn.value(columnInfo.Enabled),
                        HasContent: false,
                        HelpText: $dyn.value(columnInfo.HelpText),
                        Id: getId(columnInfo._name, columnInfo.Root),
                        IsDefaultControl: controlIsDefault,
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                        IsHyperlink: $dyn.value(columnInfo.IsHyperlink),
                        key: columnInfo._name,
                        Label: $dyn.value(columnInfo.Label),
                        Name: columnInfo._name,
                        OnBlur: lookupProps.OnBlur,
                        OnFocus: lookupProps.OnFocus,
                        OnKeyDown: lookupProps.OnKeyDown,
                        OpenLookup: lookupProps.OpenLookup,
                        Required: $dyn.value(columnInfo.Required),
                        ResolveValues: controlResolveChanges,
                        SetValidity: controlSetValidity,
                        ShowLabel: $dyn.value(columnInfo.ShowLabel),
                        Skip: $dyn.value(columnInfo.Skip),
                        Validity: { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName },
                        Width: sizing.width,
                        WidthMode: sizing.widthMode,
                    };
                    var conditionalProps = {};
                    if (columnInfo.ExtendedStyle) {
                        conditionalProps.className = columnInfo.ExtendedStyle;
                    }
                    $dyn.util.objectAssign(refGroupProps, conditionalProps);
                    refGroupControl = React.createElement(ControlLibrary.ReferenceGroupCell, refGroupProps, refGroupChildren);
                }
            }
            return refGroupControl;
        });
        $dyn.reactGrid.registerColumn("Input", function (columnInfo, parentProps) {
            var inputControl = null;
            if ($dyn.value(columnInfo.Visible)) {
                var sizing = getSizing(columnInfo, $dyn.value(columnInfo.LookupButton));
                var controlIsDefault = ((isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && (columnInfo._name === parentProps.DefaultControl)) ||
                    (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl));
                var controlIsHyperlink = $dyn.value(columnInfo.IsHyperlink);
                var controlLinkNavigate = (controlIsDefault || controlIsHyperlink) ? function (columnProps) {
                    if (isReactGridUIProps(parentProps) && parentProps.NavigationEnabled && columnProps.IsDefaultControl) {
                        parentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else if (isIReferenceGroupParent(parentProps) && parentProps.IsDefaultControl && parentProps.ParentProps.NavigationEnabled) {
                        parentProps.ParentProps.NavigationAction(columnProps.RowIndex);
                    }
                    else {
                        if ((columnInfo.listControl && columnInfo.listControl.syncManager && columnInfo.listControl.syncManager.RailsMode) ||
                            (isReactGridUIProps(parentProps) && parentProps.ForceNavigationAction && parentProps.NavigationAction)) {
                            // do not navigate away when in rails mode - OR - when grid is force handling the navigation action
                            return;
                        }
                        $dyn.getFunction(columnInfo.ExecuteHyperlink)();
                    }
                } : null;
                var controlMouseEnter = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseEnter) {
                        parentProps.OnMouseEnter(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlMouseLeave = function (event, columnProps) {
                    if ($dyn.value(this.CanHavePreview) && $dyn.value(this.RequestEnhancedPreview) && parentProps.OnMouseLeave) {
                        parentProps.OnMouseLeave(event, columnProps);
                    }
                }.bind(columnInfo);
                var controlSetValue = function (newValue, cellProps) {
                    var _this = this;
                    // Let sync manager handle set value
                    var syncManager = this.listControl.syncManager;
                    syncManager.setInternalValue(newValue, this.FieldName, this.DataSourceName);
                    syncManager.changeData(this.listControl.getTrackingIdFromRowIndex(cellProps.RowIndex), this.Name, function (syncingRowId) {
                        clearMessages.apply(_this);
                        var callback = function (retValue) {
                            syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                            var convertedValue = $dyn.util.stringToBoolean(retValue);
                            if (convertedValue) {
                                syncManager.setValidity({ override: undefined }, syncingRowId, _this._name, _this.DataSourceName);
                            }
                        };
                        $dyn.callFunction(_this.SetValue, _this, [newValue], callback /*commandCallback*/, null /*complete*/, null /*before*/, null /*throttle*/, callback /*failureCallback*/);
                    }, function (syncingRowId) {
                        var setDataVersion = syncManager.clearInternalValue(syncingRowId, _this.FieldName, _this.DataSourceName);
                        if (setDataVersion) {
                            syncManager.setDataVersion(syncingRowId, _this._name, _this.DataSourceName);
                        }
                    });
                }.bind(columnInfo);
                // Used for JSDispatcher only
                columnInfo.testSetValue = controlSetValue;
                var controlSetValidity = setValidity.bind(columnInfo);
                var lookupButtonIconName = void 0;
                if ($dyn.value(columnInfo.ReplaceOnLookup)) {
                    lookupButtonIconName = 0 /* chevronDown */;
                }
                else {
                    lookupButtonIconName = 1 /* addMultiple */;
                }
                var controlHelpText = $dyn.value(columnInfo.HelpText);
                if (controlIsHyperlink || controlIsDefault) {
                    controlHelpText = $dyn.label("ReactGrid_FollowLink");
                }
                var inputProps = {
                    AllowEdit: $dyn.value(columnInfo.AllowEdit),
                    BackgroundColor: getColor($dyn.value(columnInfo.BackgroundColor)),
                    Enabled: $dyn.value(columnInfo.Enabled),
                    ForegroundColor: getColor($dyn.value(columnInfo.ForegroundColor)),
                    HelpText: controlHelpText,
                    Id: getId(columnInfo._name, columnInfo.Root),
                    IsDefaultControl: controlIsDefault,
                    IsEmptyPassword: $dyn.value(columnInfo.IsEmptyPassword),
                    IsHyperlink: controlIsHyperlink,
                    key: columnInfo._name,
                    Label: $dyn.value(columnInfo.Label),
                    LookupButtonIconName: lookupButtonIconName,
                    MaxLength: $dyn.value(columnInfo.LimitText),
                    Name: columnInfo._name,
                    OnEditClick: getOnEditClick(columnInfo.Root),
                    OnLinkNavigate: controlLinkNavigate,
                    OnMouseEnter: controlMouseEnter,
                    OnMouseLeave: controlMouseLeave,
                    PasswordMode: $dyn.value(columnInfo.PasswordMode),
                    Required: $dyn.value(columnInfo.Required),
                    SetValidity: controlSetValidity,
                    SetValue: controlSetValue,
                    ShowLabel: $dyn.value(columnInfo.ShowLabel),
                    ShowLookupButton: $dyn.value(columnInfo.LookupButton),
                    Skip: $dyn.value(columnInfo.Skip),
                    Width: sizing.width,
                    WidthMode: sizing.widthMode,
                };
                var conditionalProps = {};
                if (columnInfo.ExtendedStyle) {
                    conditionalProps.className = columnInfo.ExtendedStyle;
                }
                var isMultiline = (columnInfo.TypeName === "MultilineInput");
                if ($dyn.value(columnInfo.LookupButton)) {
                    if (isMultiline) {
                        var enableMultilineLookup = $dyn.util.isFlightEnabled($dyn.controls.multilineLookupFeatureName);
                        if (enableMultilineLookup) {
                            conditionalProps.Multiline = isMultiline;
                            conditionalProps.Rows = $dyn.value(columnInfo.DisplayHeight);
                        }
                    }
                    $dyn.util.objectAssign(inputProps, getLookupProps(columnInfo));
                }
                else {
                    conditionalProps.Multiline = isMultiline;
                    if (isMultiline) {
                        conditionalProps.Rows = $dyn.value(columnInfo.DisplayHeight);
                    }
                }
                var alignment = $dyn.value(columnInfo.Alignment);
                if (alignment && alignment !== "Auto") {
                    conditionalProps.Alignment = alignment.toLowerCase();
                }
                var boundProperties = [];
                if ($dyn.value(columnInfo.DisplayOptions) && !$.isEmptyObject($dyn.value(columnInfo.DisplayOptions))) {
                    boundProperties.push("ContainerStyle", "InputStyle");
                    conditionalProps.ContainerStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "ContainerStyle"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.InputStyle = { FieldName: getVirtualizedFieldName(columnInfo._name, "InputStyle"), DataSourceName: columnInfo.DataSourceName };
                }
                columnInfo.pasteFromExcel = controlSetValue;
                if (columnInfo.FieldName) {
                    boundProperties.push("Value", "Validity", "DataVersion");
                    conditionalProps.Validity = { FieldName: getVirtualizedFieldName(columnInfo._name, "Validity"), DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.Value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
                    conditionalProps.DataVersion = { FieldName: getVirtualizedFieldName(columnInfo._name, "DataVersion"), DataSourceName: columnInfo.DataSourceName };
                }
                else if ($dyn.value(columnInfo.Value)) {
                    conditionalProps.Value = $dyn.value(columnInfo.Value);
                }
                conditionalProps.BoundProperties = boundProperties;
                if (isIReferenceGroupParent(parentProps)) {
                    // Validity is managed at the reference group level
                    delete inputProps.SetValidity;
                    conditionalProps.OnChange = parentProps.OnChange;
                    $dyn.util.objectAssign(inputProps, conditionalProps);
                    inputControl = React.createElement(ControlLibrary.StringEdit, inputProps);
                }
                else {
                    if (parentProps.Name === "AppListGrid" && columnInfo._name === "SysAppStore_Status") {
                        conditionalProps.Rows = 1;
                    }
                    var cellProps = {
                        IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                    };
                    $dyn.util.objectAssign(inputProps, conditionalProps, cellProps);
                    inputControl = React.createElement(ControlLibrary.StringEditCell, inputProps);
                }
            }
            return inputControl;
        });
        $dyn.reactGrid.registerControlProperties("Input", {
            Alignment: true,
            DisplayHeight: true,
            IsEmptyPassword: true,
            LimitText: true,
            PasswordMode: true,
            ReplaceOnLookup: true,
        });
        $dyn.reactGrid.registerColumn("WrappedTextControl", function (columnInfo, parentProps) {
            var linkNavigate = function () {
                $dyn.async(function () {
                    $dyn.callFunction(columnInfo.Click, columnInfo);
                }, 0, "HelpLinkCallback");
            };
            var isLink = $dyn.value(columnInfo.IsLink);
            var wrappedTextProps = {
                className: "wrappedTextControl",
                isHyperlink: isLink,
                onLinkNavigate: linkNavigate,
                readOnly: true,
                style: { lineHeight: "normal", whiteSpace: "normal", paddingLeft: 0 },
            };
            var conditionalProps = {};
            if (isLink) {
                conditionalProps.skip = false;
            }
            if (columnInfo.FieldName && columnInfo.DataSourceName) {
                conditionalProps.BoundProperties = ["value"];
                conditionalProps.value = { FieldName: columnInfo.FieldName, DataSourceName: columnInfo.DataSourceName };
            }
            else if ($dyn.value(columnInfo.Text)) {
                conditionalProps.value = $dyn.value(columnInfo.Text);
            }
            $dyn.util.objectAssign(wrappedTextProps, conditionalProps);
            return React.createElement(ControlLibrary.StaticTextCell, wrappedTextProps);
        });
        $dyn.reactGrid.registerControlProperty("WrappedTextControl", "IsLink");
        $dyn.reactGrid.registerColumn("HyperLink", function (columnInfo, parentProps) {
            var boundProperties = [];
            var baseUrl = $dyn.value(columnInfo.BaseUrl);
            if (columnInfo.BaseUrl.__ModelFieldName) {
                baseUrl = { FieldName: columnInfo.BaseUrl.__ModelFieldName, DataSourceName: columnInfo.BaseUrl.__ModelName };
                boundProperties.push("BaseUrl");
            }
            var text = $dyn.value(columnInfo.Text);
            if (columnInfo.Text.__ModelFieldName) {
                text = { FieldName: columnInfo.Text.__ModelFieldName, DataSourceName: columnInfo.Text.__ModelName };
                boundProperties.push("Text");
            }
            var openInNewWindow = $dyn.value(columnInfo.OpenInNewWindow);
            if (columnInfo.OpenInNewWindow.__ModelFieldName) {
                openInNewWindow = { FieldName: columnInfo.OpenInNewWindow.__ModelFieldName, DataSourceName: columnInfo.OpenInNewWindow.__ModelName };
                boundProperties.push("OpenInNewWindow");
            }
            var queryParamNames = [];
            var queryParamValues = [];
            var queryNamesBound = false;
            var queryValuesBound = false;
            for (var i = 1; i <= 6; i++) {
                var queryParamNameProp = "QueryParam" + i.toString() + "Name";
                var paramName = $dyn.value(columnInfo[queryParamNameProp]);
                if (columnInfo[queryParamNameProp].__ModelFieldName) {
                    paramName = { FieldName: columnInfo[queryParamNameProp].__ModelFieldName, DataSourceName: columnInfo[queryParamNameProp].__ModelName };
                    queryNamesBound = true;
                }
                if (paramName) {
                    queryParamNames.push(paramName);
                    var queryParamValueProp = "QueryParam" + i.toString() + "Value";
                    var paramValue = $dyn.value(columnInfo[queryParamValueProp]);
                    if (columnInfo[queryParamValueProp].__ModelFieldName) {
                        paramValue = { FieldName: columnInfo[queryParamValueProp].__ModelFieldName, DataSourceName: columnInfo[queryParamValueProp].__ModelName };
                        queryValuesBound = true;
                    }
                    queryParamValues.push(paramValue);
                }
            }
            if (queryNamesBound) {
                boundProperties.push("QueryParamNames");
            }
            if (queryValuesBound) {
                boundProperties.push("QueryParamValues");
            }
            var hyperlinkProps = {
                BaseUrl: baseUrl,
                BoundProperties: boundProperties,
                HelpText: $dyn.value(columnInfo.HelpText),
                Id: getId(columnInfo._name, columnInfo.Root),
                IsFixed: $dyn.controls.ReactList.freezingEnabled() && $dyn.value(columnInfo.IsFrozen),
                key: columnInfo._name,
                Label: $dyn.value(columnInfo.Label),
                Name: columnInfo._name,
                OpenInNewWindow: openInNewWindow,
                QueryParamNames: queryParamNames,
                QueryParamValues: queryParamValues,
                ShowLabel: true,
                Skip: $dyn.value(columnInfo.Skip),
                Text: text,
            };
            return React.createElement(ControlLibrary.HyperlinkCell, hyperlinkProps);
        });
        var getChildren = function (columnInfo, parentProps) {
            var e_5, _a;
            var children = [];
            var element = columnInfo._element || columnInfo.element; // Depending on if serverform bound the control
            var dynChildren = $dyn.value(element.dynChildren);
            if (dynChildren) {
                try {
                    for (var dynChildren_1 = __values(dynChildren), dynChildren_1_1 = dynChildren_1.next(); !dynChildren_1_1.done; dynChildren_1_1 = dynChildren_1.next()) {
                        var dynChild = dynChildren_1_1.value;
                        var childControl = $dyn.controlOptions(dynChild);
                        var child = $dyn.reactGrid.generateColumn(childControl, $dyn.util.objectAssign({}, parentProps, { Type: columnInfo.TypeName }));
                        children.push(child);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (dynChildren_1_1 && !dynChildren_1_1.done && (_a = dynChildren_1.return)) _a.call(dynChildren_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            return children;
        };
        var buttonControls = function (columnInfo, parentProps) {
            var sizing = getSizing(columnInfo);
            var glyphClass;
            if (columnInfo.ImageType === $dyn.ui.ImageType.symbol) {
                glyphClass = columnInfo.ImageName + "-symbol";
            }
            var handleClick = function (evt, props) {
                var executeClick = function () {
                    if ($dyn.value(columnInfo.Enabled) && columnInfo.Click) {
                        $dyn.callFunction(columnInfo.Click, columnInfo);
                    }
                };
                if (props.RowIndex !== undefined && columnInfo.listControl) {
                    var serverRowIndex = columnInfo.listControl.getRowIndexFromTrackingId($dyn.value(columnInfo.listControl.SelectedRowTrackingId));
                    if (props.RowIndex === serverRowIndex) {
                        executeClick();
                    }
                    else {
                        // Execute click in timeout so row change can be sent first
                        // return false so click doesnt stop the event propagation
                        window.setTimeout(executeClick);
                        return false;
                    }
                }
                else {
                    executeClick();
                }
            };
            var currentTheme = $dyn.ui.theme.get();
            var buttonStyle = {
                ":active": {
                    backgroundColor: "transparent",
                    color: "inherit",
                },
                ":focus": {
                    borderColor: currentTheme.accent,
                    borderStyle: "solid",
                    borderWidth: 1,
                },
                ":hover": {
                    backgroundColor: currentTheme.appBarPressed,
                },
                backgroundColor: "transparent",
                borderColor: "transparent",
                borderRadius: 2,
                fontWeight: 400,
                margin: 0,
            };
            return (React.createElement(ControlLibrary.Button, { Enabled: $dyn.value(columnInfo.Enabled), ExternalGlyphCssClass: glyphClass, Height: sizing.height, HeightMode: sizing.heightMode, HelpText: $dyn.value(columnInfo.HelpText), Id: getId(columnInfo._name, columnInfo.Root), key: columnInfo._name, Label: $dyn.value(columnInfo.Label), Name: columnInfo._name, OnClick: handleClick, ShowLabel: columnInfo.ButtonDisplay !== $dyn.ui.ButtonDisplay.imageOnly, Skip: $dyn.value(columnInfo.Skip), Style: buttonStyle, Visible: $dyn.value(columnInfo.Visible), Width: sizing.width, WidthMode: sizing.widthMode }));
        };
        $dyn.reactGrid.registerColumn("Button", buttonControls);
        $dyn.reactGrid.registerColumn("MenuItemButton", buttonControls);
        $dyn.reactGrid.registerColumn("MenuItem", buttonControls);
        $dyn.reactGrid.registerColumn("MenuButton", function (columnInfo, parentProps) {
            var sizing = getSizing(columnInfo);
            var glyphClass;
            if (columnInfo.ImageType === $dyn.ui.ImageType.symbol) {
                glyphClass = columnInfo.ImageName + "-symbol";
            }
            var handleClick = function (evt, props) {
                var executeClick = function () {
                    if ($dyn.value(columnInfo.Enabled) && columnInfo.Click) {
                        $dyn.callFunction(columnInfo.Click, columnInfo);
                    }
                };
                if (props.RowIndex !== undefined && columnInfo.listControl) {
                    var serverRowIndex = columnInfo.listControl.getRowIndexFromTrackingId($dyn.value(columnInfo.listControl.SelectedRowTrackingId));
                    if (props.RowIndex === serverRowIndex) {
                        executeClick();
                    }
                    else {
                        // Execute click in timeout so row change can be sent first
                        // return false so click doesnt stop the event propagation
                        window.setTimeout(executeClick);
                        return false;
                    }
                }
                else {
                    executeClick();
                }
            };
            return (React.createElement(ControlLibrary.MenuButton, { Enabled: $dyn.value(columnInfo.Enabled), ExternalGlyphCssClass: glyphClass, Height: sizing.height, HeightMode: sizing.heightMode, HelpText: $dyn.value(columnInfo.HelpText), Id: getId(columnInfo._name, columnInfo.Root), key: columnInfo._name, Label: $dyn.value(columnInfo.Label), Name: columnInfo._name, OnClick: handleClick, ShowLabel: columnInfo.ButtonDisplay !== $dyn.ui.ButtonDisplay.imageOnly, Skip: $dyn.value(columnInfo.Skip), Visible: $dyn.value(columnInfo.Visible), Width: sizing.width, WidthMode: sizing.widthMode }, getChildren(columnInfo, parentProps)));
        });
        $dyn.reactGrid.registerColumn("ToolbarGroup", function (columnInfo, parentProps) {
            var currentTheme = $dyn.ui.theme.get();
            var subUnit = parseInt(currentTheme.subUnit, 10);
            var buttonGroupStyle = {
                boxShadow: "0 " + (subUnit + 1) + " " + (0 - subUnit) + " " + currentTheme.appBarSeparatorColor,
            };
            return (React.createElement(ControlLibrary.ButtonGroup, { AlwaysInOverflow: $dyn.value(columnInfo.AlwaysInOverflow), Id: getId(columnInfo._name, columnInfo.Root), Style: buttonGroupStyle }, getChildren(columnInfo, parentProps)));
        });
        $dyn.reactGrid.registerColumn("Toolbar", function (columnInfo, parentProps) {
            var toolbarStyle = { margin: 0 };
            var currentTheme = $dyn.ui.theme.get();
            var overflowButtonStyle = {
                ":active": {
                    backgroundColor: "transparent",
                    color: "inherit",
                },
                ":focus": {
                    borderColor: currentTheme.accent,
                    borderStyle: "solid",
                    borderWidth: 1,
                },
                ":hover": {
                    backgroundColor: currentTheme.appBarPressed,
                },
                backgroundColor: "transparent",
                borderColor: "transparent",
                borderRadius: 2,
                color: currentTheme.accent,
                fontWeight: 400,
                margin: 0,
            };
            return (React.createElement(ControlLibrary.Toolbar, { Id: getId(columnInfo._name, columnInfo.Root), OverflowButtonStyle: overflowButtonStyle, Style: toolbarStyle }, getChildren(columnInfo, parentProps)));
        });
    })(reactGrid = $dyn.reactGrid || ($dyn.reactGrid = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ColumnGenerator.js.map
